import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { DealerEmployee } from '../models/dealer-employee.model';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Group } from '../models/group.model';
import { Report } from '../models/report.model';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  reportState: Report;

  constructor(private httpClient: HttpClient) { }

  getReport(reportGuid: string) {
    return this.httpClient.get<any>(`${environment.apis.thirdParty}/reports/${reportGuid}`);
  }

  getReports() {
    return this.httpClient.get<Report[]>(`${environment.apis.thirdParty}/reports`);
  }

  getReportsOf(bac?: string, userId?: string, adminRole?: string) {
    let url = `${environment.apis.thirdParty}/reports/of`
    if (bac) {
      url += `?bac=${bac}&`;
    } else {
      url += '?';
    }
    if (userId) {
      url += `userId=${userId}&adminRole=${adminRole}`;
    }
    return this.httpClient.get<Report[]>(url).pipe(
      catchError(error => this.handleError(error))  // Handle errors (including 404)
    );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 404) {
      console.log('No reports found, returning empty array.');
      return of([]);  // Return an empty array if a 404 error occurs
    } else {
      console.error('An unexpected error occurred:', error);
      return of([]);  // Fallback: return empty array for any other errors
    }
  }

  updateReport(report: Report) {
    return this.httpClient.post<Report>(`${environment.apis.thirdParty}/reports/update`, { report: report });
  }

  getReportIcon(report: Report) {
    return this.httpClient.get<any>(`${environment.apis.thirdParty}/reports/iconMTP?reportGuid=${report.guid}&iconFileExtension=${report.iconFileExtension}`);
  }

  uploadReportIcon(file, reportGuid: string) {
    var form = new FormData();
    form.append('upload', file)
    return this.httpClient.post<any>(`${environment.apis.thirdParty}/reports/uploadIcon/${reportGuid}`, form);
  }

  getReportSecurity(reportGuid: string) {
    return this.httpClient.get<any>(`${environment.apis.thirdParty}/reports/security/${reportGuid}`);
  }

  grantReportSecurity(groups: any[], reportId: number) {
    return this.httpClient.post<Group[]>(`${environment.apis.thirdParty}/reports/security`, { dealers: groups, reportId: reportId });
  }

  grantReportSecurityPSC(employees: DealerEmployee[], reportGuid: string) {
    return this.httpClient.post<Group[]>(`${environment.apis.thirdParty}/reports/security/psc/${reportGuid}`, { employees: employees });
  }

  removeReportSecurity(insightAccessGuids: string[]) {
    return this.httpClient.post(`${environment.apis.thirdParty}/reports/security/remove`, { insightAccessGuids: insightAccessGuids });
  }

  getEmbedToken(reportId: string, bac?: string) {
    console.log("getembedtoken",reportId);
    let url = `${environment.apis.thirdParty}/reports/embed/${reportId}`
    if (bac ) {
      url += `?bac=${bac}`
    }
    return this.httpClient.post<any>(url, {});
  }

  getPbiDashboards() {
    return this.httpClient.get<any>(`${environment.apis.thirdParty}/reports/dashboards`);
  }

  getReportsInPbiWorkspace() {
    return this.httpClient.get<any>(`${environment.apis.thirdParty}/reports/availableReports`);
  }

  getTilesInDashboard(dashboardId: string) {
    return this.httpClient.get<any>(`${environment.apis.thirdParty}/reports/dashboards/${dashboardId}`);
  }

  addReport(report: Report) {
    const body = { 'report': report }
    return this.httpClient.post<any>(`${environment.apis.thirdParty}/reports`, body);
  }
}
